import { AudienceListsActionInitiatedResponse } from '@/types/registration.types';
import { Post } from '../helpers';

export default function CloneLists({
  channel,
  projectUuid,
  registrantListsToAdd,
  passcodeListToClone,
  listsToAdd,
  addListsToProject = true,
  name,
  description,
  signal,
}: {
  channel: number;
  projectUuid: string;
  registrantListsToAdd: Record<string, string[]> | null;
  passcodeListToClone: number | null;
  listsToAdd: number[];
  addListsToProject: boolean;
  name?: string;
  description?: string;
  signal?: AbortSignal;
}) {
  return Post<AudienceListsActionInitiatedResponse>({
    url: `/v4/admin/attendees/${channel}/${projectUuid}/clone-lists`,
    body: { registrantListsToAdd, passcodeListToClone, listsToAdd, addListsToProject, name, description },
    signal,
  });
}
